<template>
    <div class="container"  v-title="'积分排名'">
        <Navigation-bar v-scrollShadow="roll < tabTop && roll" :class="{'Bokeh': regulationShow}">
            <div class="nav_title" slot="title" v-if="roll > titleTop" @click="project.show = !project.show">
                <span>{{project.name}}</span>
                <YD-image :src="project.show?'icon/icon_下拉箭头_黑色_向上':'icon/icon_下拉箭头_黑色_向下'"></YD-image>
            </div>
            <YD-image src="icon/icon_nav_分享" class="share"
                v-share="{
                    Type: 3,
                    Title: '积分排名',
                    Text: '综合考量，科学计算，为参赛队伍和个人授予成绩积分',
                    Link: 'https://m.dazhongyundong.com/app_download/',
                    LinkText: '立即下载APP：',
                    ImgLink: ''
                }" 
                v-if="$appVersion >= '22093000'"
            ></YD-image>
        </Navigation-bar>
        <div class="container_content">
            <div id="IntegralRanking" ref="IntegralRanking" :class="{'Bokeh': regulationShow}">
                <Scroll
                    :scroll="roll"
                    @scrollChange="roll = $event"
                    @scrollEnd="scrollEnd"
                >
                    <div class="IR_content">
                        <div class="title">
                            <h2>
                                <div v-show="project.name" @click="project.show = !project.show">
                                    <span>{{project.name}}</span>
                                    <YD-image :src="project.show?'icon/icon_下拉箭头_黑色_向上':'icon/icon_下拉箭头_黑色_向下'"></YD-image>
                                </div>
                            </h2>
                            <p class="subTitle">浏览积分排名</p>
                        </div>
                        <div class="regulation">
                            <YD-image src="赛事管理办法" @click.native="regulationShow = true"></YD-image>
                        </div>
                        <div class="tab" v-if="year.list.length > 0">
                            <div class="tab_fixed" :class="{'fixed':isFixed}"  v-scrollShadow="roll > tabTop">
                                <div class="condition_select">
                                    <div class="year" @click="year.show = true">
                                        <span>{{year.Id == -1 ? '历史' : year.Id}}</span>
                                        <YD-image :src="year.show ? 'icon/icon_下拉箭头_灰色_向上' : 'icon/icon_下拉箭头_灰色_向下'"></YD-image>
                                    </div>
                                    <div class="group" v-if="group.list.length > 0">
                                        <ul>
                                            <li v-for="(item,index) in group.list" :key="index"
                                                :class="{'active': item.Id == group.Id}"
                                                @click="selectGroup(item.Id)"
                                            >{{item.Name}}</li>
                                        </ul>
                                    </div>
                                </div>
                                <template v-if="project.Id == 0 && group.Id == 1">
                                    <div class="list_title company">
                                        <div>名次/机构</div>
                                        <div>积分</div>
                                    </div>
                                </template>
                                <template v-else-if="project.Id == 0 && [2,3].includes(group.Id)">
                                    <div class="list_title personal">
                                        <div>名次/{{['运动员','队伍','组合'][group.type - 1]}}</div>
                                        <div>积分</div>
                                        <div>项目</div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="list_title company">
                                        <div>名次/{{['运动员','队伍','组合'][group.type - 1]}}</div>
                                        <div>积分</div>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <ul class="list">
                            <li v-for="(item,index) in list" :key="index" 
                                :class="project.Id == 0 && [2,3].includes(group.Id) ? 'personal' : 'company'"
                            >
                                <template v-if="project.Id == 0 && group.Id == 1">
                                    <div class="info">
                                        <span class="ranking_num">{{item.Ranking}}</span>
                                        <span class="name">{{item.Name}}</span>
                                    </div>
                                    <div class="integral">{{item.Points}}</div>
                                </template>
                                <template v-else-if="project.Id == 0 && [2,3].includes(group.Id)">
                                    <div class="info">
                                        <span class="ranking_num">{{item.Ranking}}</span>
                                        <span class="name">{{item.Name}}</span>
                                    </div>
                                    <div class="integral">{{item.Points}}</div>
                                    <div class="events">{{item.EventsName}}</div>
                                </template>
                                <template v-else>
                                    <div class="info">
                                        <span class="ranking_num">{{item.Ranking}}</span>
                                        <span class="name">{{item.Name}}</span>
                                    </div>
                                    <div class="integral">{{item.Points}}</div>
                                </template>
                            </li>
                        </ul>
                        <div class="load_more" v-show="loadMore">
                            <img src="@images/no_data/暂无赛事证书@2x.png" v-show="loadMore == '无数据'">
                            <span v-show="loadMore != '无数据'">{{loadMore}}</span>
                        </div>
                    </div>
                </Scroll>
                <div class="masking" v-show="project.name && project.show" @click="project.show = false"></div>
                <div id="project_list" v-show="project.name && project.show">
                    <div class="title" v-show="roll <= titleTop">
                        <h2>
                            <div v-show="project.name" @click="project.show = !project.show">
                                <span>{{project.name}}</span>
                                <YD-image :src="project.show?'icon/icon_下拉箭头_黑色_向上':'icon/icon_下拉箭头_黑色_向下'"></YD-image>
                            </div>
                        </h2>
                        <p class="subTitle">选择运动项目</p>
                    </div>
                    <div class="project_list_content">
                        <ul>
                            <li v-for="(item,index) in project.list" :key="index" 
                                :class="{'active': item.Id == project.Id}"
                                @click="projectChange(item)"
                            >
                                {{item.Name}}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <YD-dialog :show.sync="year.show">
            <div class="dialog">
                <div class="year_list">
                    <ul>
                        <li v-for="(item,index) in year.list" :key="index"
                            :class="{'active':item == year.Id}"
                            @click.stop="selectYear(item)"
                        >{{item == -1 ? '历史排名' : (item + '年度')}}</li>
                    </ul>
                </div>
                <div class="year_option">
                    <button @click="year.show = false">取消</button>
                </div>
            </div>
        </YD-dialog>
        <div class="regulation_events" v-show="regulationShow">
            <div class="regulation_title">
                <h2>管理办法</h2>
                <p>选择一个项目</p>
            </div>
            <ul>
                <li v-for="(item,index) in project.list" :key="index" 
                    v-show="item.Id > 0"
                    @click="regulationShow = false;$navigation.go('/Rules/CertificationRegulation/'+item.Id);"
                >{{item.Name}}</li>
            </ul>
            <YD-image src="icon/icon_close" class="close" @click.native="regulationShow = false"></YD-image>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import Dialog from '@/components/Dialog';
Vue.use(Dialog);
import {
    GetEventsFlatedList,
    GetLeaguePointList
} from "@/api"
import { 
    convertSize
 } from '@js';
export default {
    name:'IntegralRanking',
    data(){
        const eventsId = parseInt(this.$route.params.eventsId),
            pointGroupId = parseInt(this.$route.params.pointGroupId),
            pointYear = parseInt(this.$route.params.pointYear);
        return {
            roll: 0,//滚动距离
            titleTop: 0,
            tabTop: 0,
            isFixed: false,
            regulationShow: false,
            project:{
                name: "",
                Id: isNaN(eventsId) ? -1 : eventsId,
                list: [],
                show: false
            },
            group:{
                list: [],
                Id: isNaN(pointGroupId) ? 0 : pointGroupId,
                type: 0,//
            },//组别
            year:{
                list: [],
                show: false,
                Id: isNaN(pointYear) ? 0 : pointYear
            },//年份
            list: [],
            lastId: 0,
            loadMore: '',
            isGetData: true,
            
        }
    },
    created(){
        var all = {Id:0,Name:'全部项目'};
        GetEventsFlatedList().then(data=>{
            if(data.Code == 0){
                var arr = data.EventsList;  
                arr.unshift(all);
                this.project.list = arr;
                if(this.project.Id > 0){
                    let obj = arr.filter(item=> item.Id == this.project.Id)[0];
                    if(obj){
                        this.project.name = obj.Name;
                        this.getListData(1, obj.Id, this.year.Id, this.group.Id, 0);
                    }else{
                        this.projectChange(all, this.year.Id, this.group.Id);
                    }
                }
            }
        })
        if(this.project.Id == -1){
            this.projectChange(all, this.year.Id, this.group.Id);
        }
    },
    mounted() {
        this.titleTop = convertSize(1.1);
        this.tabTop = convertSize(4.44);
    },
    watch:{
        roll:function(scroll, oldScroll){
            if(scroll > this.tabTop){
                this.isFixed = true;
            }else{
                this.isFixed = false;
            }
        },
        'project.show':{
            deep: true,
            handler(newVal){
                if(newVal && this.roll < this.titleTop){
                    this.roll = 0;
                }
            }
        }
    },
    methods: {
        projectChange({Id, Name}){
            if(this.project.Id != Id){
                this.project.Id = Id;
                this.project.name = Name;
                this.project.show = false;
                this.getListData(1, Id, -1, 0, 0);
            }
        },
        selectYear(year){
            if(this.year.Id != year){
                this.year.Id = year;
                this.year.show = false;
                this.getListData(2, this.project.Id, year, 0, 0);
            }
        },
        selectGroup(groupId){
            if(this.group.Id != groupId){
                this.group.Id = groupId;
                this.getListData(3, this.project.Id, this.year.Id, groupId, 0);
            }
        },
        scrollEnd(){
            if(!this.isGetData){ 
                return ;
            }
            this.getListData(4,this.project.Id, this.year.Id, this.group.Id, this.lastId);
        },
        //type 1：运动项目，2：月份 3：组别 4：滑动加载更多
        getListData(type, projectId, pointYear, pointGroupId, lastId){
             if([1, 2, 3].includes(type)){
                this.lastId = 0;
                lastId = 0;
                this.list = [];
                if(type == 1){
                    this.year.list = [];
                    this.group.list = [];
                }else if(type == 2){
                    this.group.list = [];
                }
            }
            this.isGetData = false;
            this.loadMore = '数据加载中...';
            GetLeaguePointList({
                EventsId: projectId,
                PointGroupId: pointGroupId,
                PointYear: pointYear,
                Continuation: {
                    LastId: lastId,
                    MaxCount: 20
                }
            }).then(data=>{
                this.isGetData = true;
                this.loadMore = '';
                if(data.Code == 0){
                    var PointGroupList = data.PointGroupList || [],
                        PointYearList = data.PointYearList || [],
                        PointRecordList = data.PointRecordList || [],
                        CurrentPointGroup = data.CurrentPointGroup || {},
                        CurrentPointYear = data.CurrentPointYear || 0;
                    if([1].includes(type)){
                        if(PointYearList.length > 0){
                            PointYearList.unshift(-1);
                        }
                        this.year.list = PointYearList;
                        this.year.Id = CurrentPointYear;
                    }
                    if([1, 2].includes(type)){
                        this.group.list = PointGroupList;
                        this.group.Id = CurrentPointGroup.Id;
                    }
                    this.group.type = CurrentPointGroup.Type;
                    if(PointRecordList.length == 0){
                        if(lastId == 0){
                            this.loadMore = '无数据';
                        }else{
                            this.loadMore = '';
                        }
                        this.isGetData = false;
                    }else{
                        if(lastId == 0){
                            this.list = PointRecordList;
                        }else{
                            this.list.push.apply(this.list, PointRecordList);
                        }
                        this.lastId = PointRecordList[PointRecordList.length-1].Id;
                    }
                }
            }).catch(()=>{
                this.isGetData = true;
                this.loadMore = '';
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.nav_title{
    width: auto;
    height: 50px;
    font-size: 36px;
    color: #1B1C1E;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
        width: 32px;
        height: 32px;
        margin-left: 4px;
        margin-top: 1px;
    }
}
.share,
.search{
    width: 48px;
    height: 48px;
    margin-right: -6px;
}
.search + .share{
    margin-left: 30px;
}
#IntegralRanking{
    height: 100%;
    position: relative;
    overflow: hidden;
    .IR_content{
        padding-bottom: 40px;
    }
    .title{
        width: 100%;
        height: 194px;
        padding: 24px 40px 0;
        box-sizing: border-box;
        &.fixed{
            position: absolute;
            left: 0;
            z-index: 3;
        }
        h2{
            display: inline-block;
            @include line-height(84px);
            font-size: 60px;
            color: #1B1C1E;
            font-weight: 500;
            position: relative;
            img{
                width: 40px;
                margin-left: 12px;
                margin-top: 30px;
            }
        }
        p.subTitle{
            @include line-height(44px);
            font-size: 32px;
            color: #8B8C8D;
            font-weight: 400;
            margin-top: 6px;
        }
    }
    .regulation{
        width: 100%;
        height: 288px;
        display: flex;
        justify-content: center;
        img{
            height: 100%;
        }
    }
    .tab{
        width: 100%;
        height: 168px;
        margin-top: -38px;
        .tab_fixed{
            width: 100%;
            height: 168px;
            padding-top: 16px;
            box-sizing: border-box;
            background: #fff;
            &.fixed{
                position: absolute;
                top: 0;
                left: 0;
                z-index: 1;
            }
            .condition_select{
                width: 100%;
                height: 72px;
                display: flex;
                padding-left: 40px;
                box-sizing: border-box;
                .year{
                    width: 140px;
                    height: 100%;
                    border: 2px solid rgba(244,244,244,1);
                    border-radius: 36px;
                    box-sizing: border-box;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .group{
                    width: calc(100% - 140px);
                    height: 100%;
                    position: relative;
                    &::before{
                        content: '';
                        width: 16px;
                        height: 100%;
                        background-image: linear-gradient(270deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.6) 60%, #FFFFFF 100%);
                        position: absolute;
                        top: 0;
                        left: 0;
                    }
                    ul{
                        width: 100%;
                        height: 100%;
                        overflow-x: auto;
                        white-space: nowrap;
                        padding: 0 40px 0 16px;
                        box-sizing: border-box;
                        li{
                            @include line-height(72px);
                            padding: 0 24px;
                            box-sizing: border-box;
                            background: #FAFBFA;
                            border-radius: 36px;
                            margin-right: 10px;
                            font-size: 28px;
                            color: #666666;
                            font-weight: 400;
                            display: inline-block;
                            vertical-align: middle;
                            &:last-of-type{
                                margin-right: 0;
                            }
                            &.active{
                                background: #1B1C1E;
                                color: #FFFFFF;
                                font-weight: 500;
                            }
                        }
                    }
                }
            }
            .list_title{
                width: 100%;
                height: 72px;
                margin-top: 8px;
                padding: 0 40px;
                box-sizing: border-box;
                font-size: 28px;
                color: #B9B9B9;
                font-weight: 500;
                line-height: 72px;
                display: flex;
                &.company{
                    justify-content: space-between;
                    >div:nth-of-type(1){
                        width: 332px;
                    }
                    >div:nth-of-type(2){
                        width: 100px;
                    }
                }
                &.personal{
                    >div:nth-of-type(1){
                        flex: 194;
                        // width: 194px;
                    }
                    >div:nth-of-type(2){
                        flex: 96;
                        // width: 96px;
                    }
                    >div:nth-of-type(3){
                        flex: 154;
                        // width: 154px;
                    }
                }
            }
        }
    }
    .list{
        width: 100%;
        li{
            height: auto;
            width: 100%;
            padding: 20px 40px;
            box-sizing: border-box;
            display: flex;
            &:nth-of-type(2n - 1){
                background: #FAFBFA;
            }
            &.company{
                justify-content: space-between;
                >div:nth-of-type(1){
                    width: 332px;
                }
                >div:nth-of-type(2){
                    width: 100px;
                }
            }
            &.personal{
                >div:nth-of-type(1){
                    flex: 194;
                    // width: 194px;
                }
                >div:nth-of-type(2){
                    flex: 96;
                    // width: 96px;
                }
                >div:nth-of-type(3){
                    flex: 154;
                    // width: 154px;
                }
            }
            >div{
                line-height: 40px;
                font-size: 28px;
                &.info{
                    display: flex;
                    .ranking_num{
                        width: 52px;
                        color: #F79611;
                        font-weight: 600;
                    }
                    .name{
                        width: calc(100% - 52px);
                        color: #1B1C1E;
                        font-weight: 400;
                        white-space: wrap;
                    }
                }
                &.integral{
                    color: #7AD21A;
                    font-weight: 500;
                }
                &.events{
                    color: #666666;
                    font-weight: 400;
                }
            }
        }
    }
    .masking{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.4);
        z-index: 2;
    }
    #project_list{
        width: 100%;
        height: auto;
        background: #FFFFFF;
        border-radius: 0px 0px 40px 40px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 3;
        .project_list_content{
            padding: 24px 0 24px 42px;
            box-sizing: border-box;
            ul{
                display: flex;
                flex-wrap: wrap;
                li{
                    width: 156px;
                    @include line-height(74px);
                    background: #FAFBFA;
                    border-radius: 37px;
                    font-size: 24px;
                    color: #333333;
                    text-align: center;
                    font-weight: 400;
                    margin-right: 16px;
                    margin-bottom: 16px;
                    &.active{
                        background: #1B1C1E;
                        color: #FFFFFF;
                        font-weight: 500;
                    }
                }
            }
        }
    }
}
.dialog{
    height: 910px;
    padding-top: 40px;
    box-sizing: border-box;
    position: relative;
    .year_list{
        height: 100%;
        width: 100%;
        @include scroll;
        ul {
            padding-bottom: 214px;
            li{
                width: 100%;
                height: 104px;
                line-height: 104px;
                font-size: 28px;
                color: #1B1C1E;
                text-align: center;
                font-weight: 400;
                &.active{
                    color: #7AD21A;
                    font-weight: 500;
                }
            }
        }
    }
    .year_option{
        @include bottom-button;
        height: 242px;
        position: absolute;
        bottom: -68px;
        button{
            width: 520px;
            margin-top: 42px;
        }
    }
}
.regulation_events{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    background: rgba(0,0,0,0.80);
    .regulation_title{
        width: 100%;
        position: absolute;
        top: 10.6%;
        left: 0;
        h2{
            font-size: 60px;
            color: #FFFFFF;
            font-weight: 500;
            line-height: 84px;
            text-align: center;
        }
        p{
            font-size: 32px;
            color: #999999;
            line-height: 44px;
            font-weight: 400;
            text-align: center;
            margin-top: 6px;
        }
    }
    ul{
        width: 100%;
        height: auto;
        padding-left: 36px;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        position: absolute;
        top: 26.2%;
        left: 0;
        li{
            width: 156px;
            @include line-height(74px);
            background: #FFFFFF;
            border-radius: 37px;
            font-size: 24px;
            color: #333333;
            text-align: center;
            font-weight: 400;
            margin-right: 16px;
            margin-bottom: 16px;
        }
    }
    .close{
        width: 100px;
        height: 100px;
        position: absolute;
        bottom: calc(var(--safe-area-inset-bottom) + 40px);
        left: 324px;
    }
}
</style>